import React, { Fragment, memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';
import {
  Space,
  WrapListContainer,
  IconButton,
  IconCog,
} from '@redlink/components/atoms';
import { CategoryItem } from '@redlink/components/molecules';

export const CategoryList = memo(
  ({ selectedIndex = 0, onChange, data, style, onManagePress }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();
    data = [{ id: null, title: dictionary.all }, ...data];
    return (
      <WrapListContainer {...{ style }}>
        {data.map((item, index) => {
          const isFocused = selectedIndex === index;
          return (
            <Fragment key={index}>
              <CategoryItem
                style={styles.itemContainer}
                {...{ item, isFocused }}
                onPress={() => onChange && onChange(item, index)}
              />
              <Space size={8} />
            </Fragment>
          );
        })}
        <IconButton style={styles.iconContainer} onPress={onManagePress}>
          <IconCog color={colors.gray23} />
        </IconButton>
      </WrapListContainer>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  itemContainer: {
    marginVertical: 4,
  },
  iconContainer: {
    backgroundColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
    height: 48,
    width: 48,
    borderRadius: 24,
    ...shadow.card,
  },
}));
